/* 7215179f2a5a8374692e63f8c95cb35efac44bbd
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HighlightBrandsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HighlightBrandsQuery = { __typename?: 'Query', highlightBrands?: { __typename?: 'HighlightBrands', items?: Array<{ __typename?: 'HighlightBrand', alt?: string | null, img?: string | null, description?: string | null, label?: string | null, position?: number | null, url?: string | null, id?: number | null } | null> | null, homepage_layout?: { __typename?: 'BrandLayout', banner_image?: string | null, banner_link?: string | null, border_type?: string | null, limit_qty?: number | null, row_qty?: number | null, layout?: { __typename?: 'LayoutData', label?: string | null, value?: number | null } | null } | null, category_layout?: { __typename?: 'BrandLayout', banner_image?: string | null, banner_link?: string | null, border_type?: string | null, limit_qty?: number | null, row_qty?: number | null, layout?: { __typename?: 'LayoutData', label?: string | null, value?: number | null } | null } | null } | null };


export const HighlightBrandsDocument = gql`
    query HighlightBrands {
  highlightBrands {
    items {
      alt
      img
      description
      label
      position
      url
      id
    }
    homepage_layout {
      banner_image
      banner_link
      border_type
      layout {
        label
        value
      }
      limit_qty
      row_qty
    }
    category_layout {
      banner_image
      banner_link
      border_type
      layout {
        label
        value
      }
      limit_qty
      row_qty
    }
  }
}
    `;

/**
 * __useHighlightBrandsQuery__
 *
 * To run a query within a React component, call `useHighlightBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHighlightBrandsQuery(baseOptions?: Apollo.QueryHookOptions<HighlightBrandsQuery, HighlightBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightBrandsQuery, HighlightBrandsQueryVariables>(HighlightBrandsDocument, options);
      }
export function useHighlightBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightBrandsQuery, HighlightBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightBrandsQuery, HighlightBrandsQueryVariables>(HighlightBrandsDocument, options);
        }
export function useHighlightBrandsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HighlightBrandsQuery, HighlightBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightBrandsQuery, HighlightBrandsQueryVariables>(HighlightBrandsDocument, options);
        }
export type HighlightBrandsQueryHookResult = ReturnType<typeof useHighlightBrandsQuery>;
export type HighlightBrandsLazyQueryHookResult = ReturnType<typeof useHighlightBrandsLazyQuery>;
export type HighlightBrandsSuspenseQueryHookResult = ReturnType<typeof useHighlightBrandsSuspenseQuery>;
export type HighlightBrandsQueryResult = Apollo.QueryResult<HighlightBrandsQuery, HighlightBrandsQueryVariables>;